<template>
  <div class="container">
    <div class="title wow fadeInUp">
      <p>{{titlename}}</p>
      <span v-html="textContent">{{textContent}}</span>
    </div>
    <div class="corporateduty">
      <div class="leftdiv">
        <div>
          <img :src="getimgsrc(img[0])"/>
          <p class="wow fadeInUp" v-html="$i18n.locale=='zh_HK'?name[0]:nameEn[0]">
            {{$i18n.locale=='zh_HK'?name[0]:nameEn[0]}}</p>
        </div>
        <div>
          <img :src="getimgsrc(img[1])"/>
          <p class="wow fadeInUp" v-html="$i18n.locale=='zh_HK'?name[1]:nameEn[1]">
            {{$i18n.locale=='zh_HK'?name[1]:nameEn[1]}}</p>
        </div>
      </div>
      <div class="rightdiv">
        <img :src="getimgsrc(img[2])"/>
        <p class="wow fadeInUp" v-html="$i18n.locale=='zh_HK'?name[2]:nameEn[2]">
          {{$i18n.locale=='zh_HK'?name[2]:nameEn[2]}}</p>

      </div>
    </div>
  </div>
</template>

<script>
  import {WOW} from 'wowjs';
  import {getListAbout} from '@/api/home';
  export default {
    name: "corporateDuty",
    props: ['titlename','textContent','imgsrc'],
    data(){
      return{
        listDuty:'',
        img:[],
        name:[],
        nameEn:[],
      }
    },
    mounted() {
      //解决---控制台可能会出现警告
      var options={
        //默认为true
        live:false
      }
      var wow = new WOW(options);
      wow.init();
    },
    created() {
      this.getListAbout();
    },
    methods: {
      getListAbout() {
        getListAbout() .then(response => {
          const data = response.data;
          this.listDuty=data.data[2].list;
          this.listDuty.forEach((item, index) => {
            this.img.push(item.img);
            this.name.push(item.name);
            this.nameEn.push(item.nameEn);
          });
        })
      },
      getimgsrc(imgvalue){
        if (imgvalue == null || imgvalue == '') {
          return '-'
        }
        var imgs = imgvalue.replace(/,/g, "")
        return process.env.BASE_IMG + imgs
      }
    },
  }
</script>

<style lang="less" scoped>
  // 大于800px
  @media only screen and (min-width: 800px) {
    .container {
      width: 100%;
      height: 100%;
      flex-direction: column-reverse;
      justify-content: center;
      align-items: center;
      font-size: 1em;
      color: white;
      background-color: #200A42;

      .title {
        padding-top: 5%;
        height: 30%;
        width: 100%;
        display: flex;
        align-items: center;
        flex-direction: column;
        font-size: 2em;
        z-index: 999;

        p {
          font-size: 1.4em;
        }

        span {
          margin-top: 3%;
          font-size: 0.7em;
          padding-bottom: 40px;
        }
      }

      .corporateduty {
        width: 100%;
        /*height: 100%;*/
        display: flex;
        background-color: white;
        overflow: hidden;
        font-weight: bold;
        font-size: 1.2em;

        .leftdiv {
          float: left;
          width: 68%;
          height: 100%;
          position: relative;


          img {
            width: 100%;
            height: 100%;
          }

          div:nth-child(1) {
            position: relative;
            p {
              bottom:5%;
              left: 0;
              width: 100%;
              position: absolute;
            }
          }

          div:nth-child(2) {
            margin-top: -0.5%;
            position: relative;
            p {
              bottom:5%;
              left: 0;
              width: 100%;
              position: absolute;
            }
          }
        }

        .rightdiv {
          position: relative;
          float: right;
          width: 34%;
          height: 100%;

          p {
            bottom:5%;
            left: 0;
            width: 100%;
            position: absolute;
          }

          img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
  }
  // 小于800px
  @media only screen and (max-width: 800px) {
    .container {
      width: 100%;
      height: 100%;
      flex-direction: column-reverse;
      justify-content: center;
      align-items: center;
      font-size: 1em;
      color: white;
      background-color: #200A42;

      .title {
        padding-top: 4%;
        height: 30%;
        width: 100%;
        display: flex;
        align-items: center;
        flex-direction: column;
        font-size: 2em;
        z-index: 999;

        p {
          font-size: 1.4em;
        }

        span {
          margin-top: 3%;
          font-size: 0.7em;
          padding-bottom: 3%;
        }
      }

      .corporateduty {
        width: 100%;
        height: 100%;
        display: flex;
        background-color: white;
        overflow: hidden;
        font-weight: bold;

        p{
          transform: scale(0.8);
          font-size: 1.5em;
        }
        .leftdiv {
          float: left;
          width: 67%;
          height: 100%;
          position: relative;

          img {
            width: 100%;
            height: 100%;
          }

          div:nth-child(1) {
            position: relative;

            p {
              bottom:7%;
              left: 0;
              width: 100%;
              position: absolute;
            }
          }

          div:nth-child(2) {
            margin-top: -1.5%;
            position: relative;

            p {
              bottom:5%;
              left: 0;
              width: 100%;
              position: absolute;
            }
          }
        }

        .rightdiv {
          position: relative;
          float: right;
          width: 33%;
          height: 100%;

          p {
            bottom:5%;
            left: 0;
            width: 100%;
            position: absolute;
          }

          img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/About/aboutcomponents/corporateDuty.vue